<template>
  <span class="bx-content bx-content__advertorial bx-badge--advertorial bx-typo--badge-advertorial" />
</template>
